import React from 'react';
import * as styles from 'common/components/header/Header.scss';
import { tl } from 'common/services/i18nService';
import { Menu, Icon, SemanticICONS } from 'semantic-ui-react';
import { hasAccessToEventLogsForUser } from 'common/services/permissions/commonPermissionService';
import { SyncClickActions } from '../../services/externalSystemService';

export interface ActionData {
    actionName: string;
    onClick: any;
    iconName?: SemanticICONS;
    leftSide?: any;
    rightSide?: any;
    disabled?: boolean;
}

interface SyncActionsProps {
    actionData: ActionData[];
    bothSideOptions?: any;
}

export const SyncActions: React.FC<SyncActionsProps> = React.memo(
    ({ actionData, bothSideOptions }) => {
        const hasEventLogAccess = hasAccessToEventLogsForUser();
        const filteredActionData = actionData.filter((action) => {
            if (action.actionName === SyncClickActions.SYNC_ERROR_LOG) {
                return hasEventLogAccess;
            }
            return true;
        });
        return (
            <Menu
                vertical
                fluid
                borderless
                secondary
                className={`${styles.cardStyles} ${styles.syncMenu}`}
            >
                {filteredActionData?.map((action: ActionData) => {
                    return (
                        <Menu.Item
                            key={action.actionName}
                            onClick={action.onClick}
                            className={styles.actionItem}
                            fitted="horizontally"
                            disabled={action.disabled}
                        >
                            {bothSideOptions ? (
                                <div className={styles.transferButton}>
                                    <span>{action.leftSide}</span>
                                    <span>{action.rightSide}</span>
                                </div>
                            ) : (
                                <div className={styles.syncActionBox}>
                                    <span>
                                        {tl(
                                            `grading.header.optionsMenu.action.${
                                                action.actionName.split(
                                                    '/'
                                                )[1]
                                            }`
                                        )}
                                    </span>
                                    <span>
                                        <Icon name={action.iconName} />
                                    </span>
                                </div>
                            )}
                        </Menu.Item>
                    );
                })}
            </Menu>
        );
    }
);
